import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { azureFetch } from "../../../api/azureFetch";


function useGetTrainModelScores(sensorId, modelId, currTab, list) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (sensorId && currTab === "scores") {

            setLoading(true);
            azureFetch("getTrainedModelPerformanceRatings", {
                sensor: sensorId,
                model_id: modelId}).then((result) => {
                    const sensorData = result;
                    const scores = {
                        mse: sensorData.latestMseScore,
                        mseWT: sensorData.latestMSEWTScore,
                        r2: sensorData.latestR2Score,
                        r2WT: sensorData.latestR2WTScore,
                        rating: sensorData.sensorRating,
                    };
                    setData(scores);
                })
                .catch((error) => {
                    console.error(error);
                    toast.error("Error fetching train model scores")
                    setData(null);
                })
                .finally(() => setLoading(false));
        }

    }, [sensorId, currTab, modelId, list]);
    return { data, loading };
}

export default useGetTrainModelScores;